(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tp-open-status"] && !Shopify.designMode) return;
  try {
    // <tp-open-status> — Live-Öffnungsstatus, jede Instanz self-init/self-cleanup.
  (function () {
    var DEFAULT = {
      1: [['09:30', '13:00'], ['13:30', '18:00']], 2: [['09:30', '13:00'], ['13:30', '18:00']],
      3: [['09:30', '13:00'], ['13:30', '18:00']], 4: [['09:30', '13:00'], ['13:30', '18:00']],
      5: [['09:30', '13:00'], ['13:30', '18:00']]
    };
    var DAYS = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
    function toMin(s) { var p = s.split(':'); return parseInt(p[0], 10) * 60 + parseInt(p[1], 10); }
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function dateStr(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
    function getConfig() {
      var cfg = { regular: DEFAULT, special: [] }, s = document.querySelector('[data-tp-store-hours]');
      if (s) { try { var p = JSON.parse(s.textContent); if (p.regular) { cfg.regular = p.regular; } if (p.special) { cfg.special = p.special; } } catch (e) { /* noop */ } }
      return cfg;
    }
    function dayInfo(cfg, d) {
      var ds = dateStr(d), i;
      for (i = 0; i < cfg.special.length; i++) {
        var sp = cfg.special[i];
        if (sp.date === ds) {
          if (!sp.closed && sp.from && sp.to) { return { intervals: [[sp.from, sp.to]], closed: false, label: sp.label || '' }; }
          return { intervals: [], closed: true, label: sp.label || '' };
        }
      }
      return { intervals: cfg.regular[d.getDay()] || [], closed: false, label: '' };
    }
    function computeLabel() {
      var cfg = getConfig(), now = new Date(), m = now.getHours() * 60 + now.getMinutes();
      var info = dayInfo(cfg, now), today = info.intervals, open = false, closeAt = null, nextToday = null, i;
      for (i = 0; i < today.length; i++) {
        var a = toMin(today[i][0]), b = toMin(today[i][1]);
        if (m >= a && m < b) { open = true; closeAt = today[i][1]; }
        if (m < a && nextToday === null) { nextToday = today[i][0]; }
      }
      var label, sp = info.label ? (' · ' + info.label) : '';
      if (open) {
        label = 'Jetzt geöffnet' + sp + ' · bis ' + closeAt + ' Uhr';
      } else {
        var openAt = nextToday, prefix = '';
        if (openAt === null) {
          for (i = 1; i <= 7; i++) {
            var fd = new Date(now.getTime() + i * 86400000), fi = dayInfo(cfg, fd);
            if (fi.intervals && fi.intervals.length) { openAt = fi.intervals[0][0]; prefix = (i === 1 ? 'morgen ' : DAYS[fd.getDay()] + ' '); break; }
          }
        }
        label = 'Jetzt geschlossen' + sp + (openAt ? (' · öffnet ' + prefix + openAt + ' Uhr') : '');
      }
      return { open: open, label: label };
    }

    class TpOpenStatus extends HTMLElement {
      connectedCallback() {
        this._update();
        this._timer = setInterval(this._update.bind(this), 60000);
      }
      disconnectedCallback() {
        clearInterval(this._timer);
      }
      _update() {
        var res = computeLabel();
        this.classList.remove('is-open', 'is-closed');
        this.classList.add(res.open ? 'is-open' : 'is-closed');
        var lab = this.querySelector('.tp-open__label');
        if (lab) { lab.textContent = res.label; }
      }
    }

    if (!customElements.get('tp-open-status')) {
      customElements.define('tp-open-status', TpOpenStatus);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
